import React from "react";
import Typography from "@mui/material/Typography";
import pictureTeaserCardStyle from "@/src/components/Cards/PictureTeaserCard/pictureTeaserCardStyle";
import { Box, Stack } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx";
import Paper from "@mui/material/Paper";

type PictureTeaserCardProps = {
  image: string;
  title: string;
  subTitle?: string;
  isLightVariant?: boolean;
};

export default function PictureTeaserCard({ image, title, subTitle, isLightVariant = false }: PictureTeaserCardProps) {
  return (
    <Paper
      sx={mergeSx(pictureTeaserCardStyle.card, (theme) => ({
        background: isLightVariant ? theme.palette.background.light : "transparent",
      }))}
      elevation={0}
    >
      <Box component={"img"} src={image} alt={title} sx={pictureTeaserCardStyle.image} />
      <Stack
        sx={mergeSx(pictureTeaserCardStyle.textContainer, (theme) => ({
          background: isLightVariant ? "transparent" : theme.palette.gradients.blackFade,
        }))}
      >
        <Typography
          sx={(theme) => ({
            color: isLightVariant ? "text.primary" : theme.palette.primary.contrastText,
          })}
        >
          {title}
        </Typography>
        {subTitle && (
          <Typography
            variant={"body3"}
            sx={(theme) => ({
              color: isLightVariant ? "text.primary" : theme.palette.primary.contrastText,
            })}
          >
            {subTitle}
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
